import { useQuery } from '@tanstack/react-query'
import { graphApi } from '@/services/api/graph'

/**
 * Fetches per-node unloaded-neighbour counts grouped by entity label for the
 * investigation graph view. Used to render the "+N" expansion-hint badge on
 * nodes whose underlying Neo4j neighbours aren't yet in the view.
 *
 * `visibleNodeIds` is sorted before keying the cache so the same set of ids
 * in any order shares one entry (handy because callers tend to pass mapped
 * arrays without a stable order).
 */
export function useNeighborCounts(caseId: string, visibleNodeIds: string[]) {
  const sortedIds = [...visibleNodeIds].sort()
  return useQuery({
    queryKey: ['graph', 'neighbor-counts', caseId, sortedIds],
    queryFn: async () => {
      if (sortedIds.length === 0) return { counts: {} as Record<string, Record<string, number>> }
      return graphApi.getNeighborCounts(caseId, sortedIds)
    },
    enabled: Boolean(caseId) && sortedIds.length > 0,
    staleTime: 30_000,
  })
}
